import { useCallback, useEffect, useState } from 'react';

/**
 * Hook simple pour persister une string dans localStorage.
 * Au MVP, on stocke le pseudo + le playerId courant.
 */
export function useLocalStorage(key: string, initial = ''): [string, (value: string) => void] {
  const [value, setValue] = useState<string>(() => {
    if (typeof window === 'undefined') return initial;
    return window.localStorage.getItem(key) ?? initial;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (value) {
      window.localStorage.setItem(key, value);
    } else {
      window.localStorage.removeItem(key);
    }
  }, [key, value]);

  const update = useCallback((next: string) => setValue(next), []);

  return [value, update];
}
